<!--赖传峰-->
<!--2021/12/15-->
<!--eslint-disable max-len-->
<template>
  <PathSlot v-bind="props">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M5 6H19V9.5H5L5 6ZM3 6C3 4.89543 3.89543 4 5 4H19C20.1046 4 21 4.89543 21 6V9.5C21 10.6046 20.1046 11.5 19 11.5H5C3.89543 11.5 3 10.6046 3 9.5V6ZM5 14.5H19V18H5L5 14.5ZM3 14.5C3 13.3954 3.89543 12.5 5 12.5H19C20.1046 12.5 21 13.3954 21 14.5V18C21 19.1046 20.1046 20 19 20H5C3.89543 20 3 19.1046 3 18V14.5Z" :fill="props.color"/>
  </PathSlot>
</template>

<script
  lang="ts"
  setup
>
import iconPropsType from './iconPropsType'
import PathSlot from './PathSlot.vue'

const props = defineProps(iconPropsType)
</script>
